import routes from '../routes/index.routes';
import { BidderChangesLogs } from '../../pages/bidder-changes-logs/index/bidder-changes-logs.page';

export const BidderChangesLogsRouter = [
	{
		path: routes.bidderChangesLogs.index(),
		element: <BidderChangesLogs />,
	},
];
